/**
 * The regime overlays, and how a surface reaches the right one (P415).
 */
import { cbuae } from "shared/i18n/regime/cbuae";
import { dora } from "shared/i18n/regime/dora";
import { osfi } from "shared/i18n/regime/osfi";
import { sama } from "shared/i18n/regime/sama";
import type { RegimeVocab, RegimeVocabByLanguage } from "shared/i18n/regime/types";

export type {
  AdmissionPathway,
  OutcomeCategory,
  RegimeVocab,
} from "shared/i18n/regime/types";

export const REGIME_VOCAB: Record<string, RegimeVocabByLanguage> = {
  sama,
  cbuae,
  dora,
  osfi,
};

/**
 * The overlay for a regime and language.
 *
 * FALLS BACK WITHIN THE REGIME, NEVER ACROSS ONE. An unknown language
 * gets that regime's English; an unknown REGIME gets null, and the
 * caller decides. Falling back to SAMA would put a Saudi regulator's
 * vocabulary on another regulator's screen, which is worse than an
 * untranslated word because it reads as authoritative.
 */
export function regimeVocab(
  code: string | null | undefined,
  language: string,
): RegimeVocab | null {
  if (!code) return null;
  const byLanguage = REGIME_VOCAB[code];
  if (!byLanguage) return null;
  // BCP 47: "ar-SA" resolves on "ar".
  const base = language.split("-")[0] ?? language;
  return byLanguage[language] ?? byLanguage[base] ?? byLanguage.en ?? null;
}
